import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { ComponentType, SVGProps } from "react";

// Class names Fluent UI components (Button, Tab, MenuItem, ...) rely on to swap filled/regular icons on hover or selection
const iconFilledClassName = "fui-Icon-filled";
const iconRegularClassName = "fui-Icon-regular";

const useBundledIconStyles = makeStyles({
  root: { display: "none" },
  visible: { display: "inline" },
});

type IconProps = SVGProps<SVGSVGElement>;

export type BundledIconProps = IconProps & { filled?: boolean };

/**
 * Combine the filled and regular versions of an icon so Fluent UI components can toggle between them.
 * Drop-in replacement for `bundleIcon` from `@fluentui/react-icons`.
 */
export const bundleIcon = (FilledIcon: ComponentType<IconProps>, RegularIcon: ComponentType<IconProps>) => {
  const Component = ({ className, filled, ...rest }: BundledIconProps) => {
    const styles = useBundledIconStyles();

    return (
      <>
        <FilledIcon
          {...rest}
          className={mergeClasses(styles.root, filled && styles.visible, iconFilledClassName, className)}
        />
        <RegularIcon
          {...rest}
          className={mergeClasses(styles.root, !filled && styles.visible, iconRegularClassName, className)}
        />
      </>
    );
  };
  Component.displayName = "CompoundIcon";

  return Component;
};
